module.exports = __webpack_public_path__ + "static/media/explorar-unid-xs.10adf195.jpg";